import { pdf } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'cswa-mechanical-design',
  title: 'CSWA — Mechanical Design',
  summary: 'Certified SolidWorks Associate in Mechanical Design.',
  cover: { src: '/assets/CSWA-P04.png', alt: 'CAD render of a chamfered bracket with a hollow rectangular pocket and a bolt hole through each wing' },
  tags: ['Certification'],
  order: 12,
  blocks: [
    pdf('/assets/Certificate_C-HWB2LP67NG.pdf', 'CSWA — Mechanical Design certificate'),
  ],
}

export default project
